import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ApisService } from 'src/app/service/APIs/apis.service';
import { AlertServiceService } from 'src/app/service/alert/alert-service.service';
import { environment } from 'src/environments/environment';
import { Country, State, City } from 'country-state-city';

@Component({
  selector: 'app-become-merchant',
  templateUrl: './become-merchant.component.html',
  styleUrls: ['./become-merchant.component.scss']
})
export class BecomeMerchantComponent implements OnInit {
  public merchantForm: FormGroup | any | undefined;
  public broadcastMsg: boolean = false;
  public privacyPolicy: boolean = false;

  public countries: any;


  baseUrl = environment.baseUrl
  constructor(
    private apiService: ApisService,
    private formBuilder: FormBuilder,
    private alert: AlertServiceService) { }

  registerMerchant() {
    if (this.privacyPolicy == false)
    return this.alert.errorPop('Privacy policy must be consented to');

    // console.log('testing if it got it', this.merchantForm.value);
    this.alert.showLoading();
    if (this.merchantForm.valid != true) {
      this.alert.errorPop('Kindly check if the * is properly filled');
      return;
    }
    let data: any = {
      firstName: this.merchantForm.value.firstName,
      lastName: this.merchantForm.value.lastName,
      email: this.merchantForm.value.email,
      phoneNumber: this.merchantForm.value.mobile,
      businessName: this.merchantForm.value.businessName,
      website: this.merchantForm.value.businessWebsite,
      size: this.merchantForm.value.businessSize,
      product: this.merchantForm.value.businessPrimaryProduct,
      country: this.merchantForm.value.country,
      payment: this.merchantForm.value.monthlyPaymentSize,
      description: this.merchantForm.value.more,
      noPosReq: parseInt(this.merchantForm.value.noPosReq)
    }
    // console.log('data', data);


    this.apiService.becomeMerchant(data)
      .subscribe({
        next: (data: any) => {
          // console.log('response', data);
          this.alert.successPop(data?.message);

        },
        error: (err) => {
          // console.log("error", err);
          this.alert.errorPop('Either Email, Phone number, Business name, website already taken, kindly Check');
        }
      });

  }

  /**get all the countries */
  getCountries() {
    this.apiService.getCountry()
      .subscribe({
        next: (data: any) => {
          // console.log('response', data);
          this.countries = data;
        },
        error: (err) => console.log("error", err)
      })
  }


  /**unchecked for broadcast */
  uncheckBroadcastMsg() {
    this.broadcastMsg = !this.broadcastMsg
  }
    /**unchecked for broadcast */
    uncheckPrivacyPolicy() {
      this.privacyPolicy = !this.privacyPolicy
    }

  ngOnInit(): void {

    // console.log('all countries', Country.getAllCountries());
    this.countries = Country.getAllCountries();

    // this.getCountries();

    this.merchantForm = this.formBuilder.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: ['', [Validators.required]],
      mobile: ['', [Validators.required]],
      businessName: ['', [Validators.required]],
      businessWebsite: ['n/a', [Validators.required]],
      businessSize: ['', [Validators.required]],
      businessPrimaryProduct: ['', [Validators.required]],
      country: ['Nigeria', [Validators.required]],
      monthlyPaymentSize: ['', [Validators.required]],
      noPosReq: [1, [Validators.required]],
      more: ['', [Validators.required]],
    });
  }



}
